/** "Hesap bilgilerim" kendi sekmesinde açılır; ScreenHost bu ekran tipiyle eşleştiriyor. */
import { useTabsStore } from '@/features/shell/tabs/tabsStore';

export const ACCOUNT_TAB_TYPE = 'account';

export function openAccountTab(caption: string) {
  return useTabsStore.getState().openCustom({
    kind: 'account',
    screenTypeName: ACCOUNT_TAB_TYPE,
    caption,
    params: {},
    // Tek sekme: ikinci kopya aynı veriyi ikinci kez çekmekten başka bir şey yapmaz.
    uniqueKey: 'account',
  });
}
